/**
 * Sanitizes values exported to CSV / Excel to prevent CSV/Formula Injection attacks (CWE-1236).
 * Prepends a single quote (') to strings that begin with formula trigger characters (=, +, -, @, \t, \r, %),
 * ensuring spreadsheet software (Excel, LibreOffice, Google Sheets) treats them as plain text instead of executing formulas.
 */
export const sanitizeForExcel = (value: any): any => {
  if (value === null || value === undefined) {
    return "";
  }

  if (typeof value === "number") {
    if (isNaN(value) || !isFinite(value)) {
      return "";
    }
    return value;
  }

  if (typeof value === "boolean") {
    return value;
  }

  const str = String(value);

  // Check if string starts with formula trigger characters
  const trimmed = str.trimStart();
  const formulaTriggers = ["=", "+", "-", "@", "\t", "\r", "%"];

  if (trimmed.length > 0 && formulaTriggers.some((char) => trimmed.startsWith(char))) {
    // Allow pure negative numbers like "-123" or "-12.5" to remain as numbers
    if (/^-\d+(\.\d+)?$/.test(trimmed)) {
      return str;
    }
    // Prefix with single quote to force Excel/Spreadsheet to treat the cell strictly as text
    return `'${str}`;
  }

  return str;
};
